module.exports = __webpack_public_path__ + "img/Planning.1231a350.svg";